export const requirements = {
  Mapped_Protocol_Questions: "Questions de protocole mappées",
  Requirement_content: "Contenu de l'exigence",
  Requirement_Ref: "Réf. de l'exigence",
  Requirements: "Exigences",
  Section_Ref: "Réf. de section",
  Section_Title: "Titre de section",
  Standard: "Standard",
  Standard_Requirements: "Exigences du standard",
  Standards: "Standards",
  Sub_Section_Ref: "Réf. de sous-section",
  Sub_Section_Title: "Titre de sous-section",
} as const;
